module.exports = __webpack_public_path__ + "static/media/H21.fa1f68a9.png";